import { render } from "./ClientCCTV.vue?vue&type=template&id=0702169d"
import script from "./ClientCCTV.vue?vue&type=script&lang=js"
export * from "./ClientCCTV.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__